'use strict'
var twentyninetimes = twentyninetimes || {}

twentyninetimes.loadMore =
  twentyninetimes.loadMore ||
  (function () {
    function init() {
      let load_more_btn = document.getElementById('js-load-more-btn')

      if (load_more_btn) load_more(load_more_btn)
    }

    function load_more(btn_wrapper) {
      var btn = btn_wrapper.querySelector('button')
      if (!btn) return

      var btn_text = btn.innerHTML,
        posts_list = btn_wrapper.previousElementSibling

      btn.addEventListener('click', function (e) {
        e.stopPropagation

        btn.innerHTML = '<span>Henter...</span>'

        request_new_posts(btn, btn_text, posts_list)
      })
    }

    function request_new_posts(btn, btn_text, posts_list) {
      // https://getbutterfly.com/how-to-replace-jquery-ajax-with-vanilla-javascript-in-wordpress/
      var xhr = new XMLHttpRequest(),
        method = 'POST',
        url = load_more_params.ajaxurl,
        action = 'load_more_posts',
        query = load_more_params.posts,
        page = load_more_params.current_page,
        count_elm = btn.parentNode.querySelector('.js-load-more-counter')

      xhr.open(method, url, true)
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;')
      xhr.send('action=' + action + '&query=' + query + '&page=' + page)

      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 400) {
          // If successful
          let new_posts = xhr.responseText,
            posts = posts_list.innerHTML

          posts += new_posts

          posts_list.innerHTML = posts

          load_more_params.current_page++

          // Update the counter after new posts are loaded
          let post_counter = posts_list.childElementCount
          count_elm.innerHTML = post_counter

          // If more pages keep button visible else hide it
          if (load_more_params.current_page < load_more_params.max_num_pages) {
            btn.innerHTML = btn_text
          } else {
            btn.parentNode.removeChild(btn)
          }
        } else {
          // If fail
          console.log(xhr.response)
        }
      }

      xhr.onerror = function () {
        alert('Something went wrong... Please try again later')
      }
    }

    return {
      init: init,
    }
  })()
